import { flow, applySnapshot } from 'mobx-state-tree';
import { getIdentifier, toMapById } from '~/mst/utils';
import api from '~/api';
import type { IReportsModel } from './model';

type CreateReportPayload = {
  organization_name: string;
  name: string;
  description?: string;
  configuration: any;
};

export default (self: IReportsModel) => ({
  fetch: flow(function* fetch(params, options) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.reports.fetch, params, options);
      applySnapshot(
        self.models,
        toMapById(
          data.map((report) => {
            let assets = null;
            if (report.assets?.html) {
              const periodKey = report.assets.html.split('/').slice(-2, -1)[0];
              assets = {
                models: [
                  {
                    id: `${report.id}_${periodKey}`,
                    period_key: periodKey,
                    html: {
                      url: report.assets.html,
                      status: 'completed'
                    },
                    ...(report.assets?.pdf && {
                      pdf: {
                        url: report.assets.pdf,
                        status: 'completed'
                      }
                    })
                  }
                ]
              };
            }
            return { ...report, assets };
          }),
          'id'
        )
      );
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),

  destroy: flow(function* destroy(report) {
    report.startSyncing();
    try {
      yield api.reports.destroy(getIdentifier(report)!);
      report.finishSyncing();
      self.remove(report);
    } catch (error) {
      report.failSyncing(error);
      throw new Error(error, { cause: error });
    }
  }),

  create: flow(function* create(payload: CreateReportPayload) {
    self.startSyncing();
    try {
      const { data } = yield api.reports.create(payload);
      self.models.put(data);
      self.finishSyncing();
      return data;
    } catch (error) {
      self.failSyncing(error);
    }
    return null;
  })
});
